// Material UI
import { Grid, Chip, Icon, FormHelperText } from '@mui/material';

// Componentes
import TextFieldTK from '@components/Form/TextFieldTK';

// Utils
import { getFormikUtil } from '@utils/Utilities';

const UserForm = (props) => {
  const { isLoading, formik, showChip = true } = props;

  const getFormik = (value) => getFormikUtil(formik, 'account', value);

  const handleUsuario = ({ target: { value } }) => {
    formik.setValues({
      ...formik.values,
      contact: { ...formik.values.contact, Celular: value },
      account: { ...formik.values.account, PIN: value?.substring(0, 5) || '' },
    });
  };

  return (
    <Grid container spacing={3}>
      {showChip && (
        <Grid item xs={12}>
          <Chip icon={<Icon>person</Icon>} label="Datos de Usuario" />
        </Grid>
      )}

      <Grid item xs={12} sm={12} md={4} lg={4}>
        <TextFieldTK
          required
          fullWidth
          label="Usuario"
          name="contact.Celular"
          placeholder="Ingresa tu Celular"
          value={formik.values.contact.Celular}
          onChange={handleUsuario}
          disabled={isLoading}
          error={formik.touched?.contact?.Celular && Boolean(formik.errors?.contact?.Celular)}
          helperText={formik.touched?.contact?.Celular && formik.errors?.contact?.Celular}
          useTrim
          isNumber
          maxLength={10}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4}>
        <TextFieldTK
          required
          fullWidth
          name="account.Password"
          label="Contraseña"
          value={getFormik('Password')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('Password')?.error}
          helperText={getFormik('Password')?.helperText}
          useTrim
          noSpaces
          isPassword
        />

        <FormHelperText sx={{ textAlign: 'end' }}>
          La contraseña debe contener mínimo 8 carácteres, una letra mayúscula, número y símbolo especial (* _
          . @)
        </FormHelperText>
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4}>
        <TextFieldTK
          required
          fullWidth
          name="account.Confirm"
          label="Repetir Contraseña"
          value={getFormik('Confirm')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('Confirm')?.error}
          helperText={getFormik('Confirm')?.helperText}
          useTrim
          noSpaces
          isPassword
        />
      </Grid>

      {/* <Grid item xs={6} sm={12} md={2} lg={2}>
        <TextFieldTK
          required
          fullWidth
          type="tel"
          name="account.PIN"
          label="PIN"
          value={getFormik('PIN')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('PIN')?.error}
          helperText={getFormik('PIN')?.helperText}
          maxLength={5}
        />

        <FormHelperText sx={{ textAlign: 'end' }}>PIN Para tener acceso a la app sin internet</FormHelperText>
      </Grid> */}
    </Grid>
  );
};

export default UserForm;
